module.exports = __webpack_public_path__ + "static/media/x-phone-red.8bd7ec9c.svg";